import Vue from 'vue';

import PhoneNumberInputVue from './PhoneNumberInput.vue';

export default function phoneNumberInputComponent(_Vue: typeof Vue) {
  _Vue.component('AppPhoneNumberInput', PhoneNumberInputVue);
}
